// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{
		"applicantId": '',
		"busDate": "",
		"clinicId": '',
		"createId": '',
		"createTime": "",
		"docNum": "",
		"id": '',
		"list": [
			{
				"clinicId": 0,
				"docId": 0,
				"dosUnt": "",
				"drugId": 0,
				"drugName": "",
				"drugSpec": "",
				"id": 0,
				"prodentpName": "",
				"prodentpNameId": 0,
				"purcAmt": 0,
				"purcCnt": 0,
				"purcPric": 0,
				"purcType": 0,
				"remarks": "",
				"stockCnt": 0,
				"supplierName": "",
				"supplyCandidateId": 0
			}
		],
		"nullifyId": '',
		"nullifyTime": "",
		"passingOrdersId": '',
		"passingOrdersTime": "",
		"putInDep": 2,
		"remarks": "",
		"reviewId": '',
		"reviewTime": "",
		"state": '',
		"supplyCandidateId": '',
		"terminalId": "",
		"totalAmt": ''
	}
]

